export default "__VITE_ASSET__BxyZH7zE__"